import React from 'react';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';

// Puramente apresentacional — nenhum import de service, nenhum hook de leitura do Apollo,
// nenhum fetch (ai/architecture.core.md §5). Mapa único cobrindo os três vocabulários de status
// consumidos pelo hub financeiro (mirror de PaymentStatusChip.tsx:9-18): pagamento, reembolso
// e agendamento. `PaymentStatusChip`/`RefundStatusChip` continuam existindo intocados nesta
// fase — migrar os call sites é da Phase 5.

export interface StatusChipFinanceiroProps {
  status: string;
}

const COLORS: Record<string, { label: string; color: string; bg: string }> = {
  // pagamento
  PAGO: { label: 'Pago', color: '#28a745', bg: 'rgba(40,167,69,0.2)' },
  PENDENTE: { label: 'Pendente', color: '#f0ad4e', bg: 'rgba(240,173,78,0.2)' },
  CANCELADO: { label: 'Cancelado', color: '#6c757d', bg: 'rgba(108,117,125,0.2)' },
  ESTORNADO: { label: 'Estornado', color: '#17a2b8', bg: 'rgba(23,162,184,0.2)' },
  GRATUITO: { label: 'Gratuito', color: '#20c997', bg: 'rgba(32,201,151,0.2)' },
  CHARGEBACK: { label: 'Chargeback', color: '#dc3545', bg: 'rgba(220,53,69,0.2)' },
  PEDIDO_REEMBOLSO: { label: 'Pedido reembolso', color: '#6f42c1', bg: 'rgba(111,66,193,0.2)' },
  // reembolso
  APROVADO: { label: 'Aprovado', color: '#28a745', bg: 'rgba(40,167,69,0.2)' },
  RECUSADO: { label: 'Recusado', color: '#dc3545', bg: 'rgba(220,53,69,0.2)' },
  FINALIZADO: { label: 'Finalizado', color: '#17a2b8', bg: 'rgba(23,162,184,0.2)' },
  // agendamento
  ABERTO: { label: 'Pendente', color: '#f0ad4e', bg: 'rgba(240,173,78,0.2)' },
  AGUARDANDO_PAGAMENTO: { label: 'Aguardando pagamento', color: '#f0ad4e', bg: 'rgba(240,173,78,0.2)' },
  EXPIRADO: { label: 'Expirado', color: '#dc3545', bg: 'rgba(220,53,69,0.2)' },
};

const StatusChipFinanceiro: React.FC<StatusChipFinanceiroProps> = ({ status }) => {
  const cfg = COLORS[status] || { label: status, color: '#6c757d', bg: 'rgba(108,117,125,0.2)' };
  return (
    <Chip
      label={cfg.label}
      className="ps-2"
      sx={{
        backgroundColor: cfg.bg,
        color: cfg.color,
        fontWeight: 500,
        '& .MuiChip-icon': { marginLeft: 0, marginRight: 0.5 },
      }}
      icon={<Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cfg.color }} />}
      size="small"
    />
  );
};

export default StatusChipFinanceiro;
